import React,{useState } from 'react'
import { ToastContainer } from "react-toastify";

import {data} from "./data";
import ErrorBoundary from "components/ErrorBoundary";
import SearchPayor from './components/SearchPayor';

import { Card, CardBody, Container } from 'reactstrap';
import PayorTable from './components/PayorTable';

const PayorSearch = () => {
  const [state, updateState] = useState({
    payorData: [],
    loading: false,
  });

  const [pageFilter, setPageFilter] = useState({
    page: 1,
    pageSize: 10,
    records: 0
  });


  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));

  let copyData = [...data];

  const handlePageChange = ({currentPage: page}) => {
    const { pageSize } = pageFilter;
    console.log({page})
    setState({loading: true})
    setTimeout(() => {
      let splicedData = copyData.slice((page === 1 ? 0 : page * pageSize) , pageSize * (page + 1));
      setPageFilter(pre => ({...pre, page: page}));
      setState({loading: false, payorData: splicedData });
    },600);
  };

  const onSearch = () => {
    const { page, pageSize } = pageFilter;
    setState({ loading: true });
    setTimeout(() => {
      let splicedData = copyData.slice((page === 1 ? 0 : page * pageSize) , pageSize);
      setPageFilter(pre => ({...pre, records: copyData.length}))
      setState({
        loading: false,
        payorData: splicedData,
      });
    }, 2000);
  };

  const onReset = () => {
    setState({ payorData: [] });
  };

  const onPageSizeChange = ({pageSize}) => {
    setState({loading: true})
    setTimeout(() => {
      let splicedData = copyData.slice(0, pageSize);
      setPageFilter(pre => ({...pre, pageSize: pageSize, page: 1}));
      setState({loading: false, payorData: splicedData})
    },600);
  };

  const { payorData, loading } = state;
  return (
    <div>
      <Container fluid className="my-3">
        <Card className="border-0 shadow-top">
          <CardBody className="section-devider-border">
            <ErrorBoundary>
              <SearchPayor onSearch={onSearch} onReset={onReset} />
            </ErrorBoundary>
          </CardBody>
          <CardBody>
            <ErrorBoundary>
            <PayorTable
              data={payorData}
              loading={loading}
              onPageChange={handlePageChange}
              // onSearchColumnFilters={handleSearchColumnFilters}
              onPageSizeChange={onPageSizeChange}
              pageFilter={pageFilter}
            />
          </ErrorBoundary>
          </CardBody>
        </Card>
      </Container>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  )
}

export default PayorSearch;